module.exports = __webpack_public_path__ + "static/media/trial3_6.5470de3a.png";